import { mapActions } from 'vuex';
import PageKeyNames from '@/utils/page-key-names';
import _ from 'lodash';

// vuex
import { mapGetters } from 'vuex';

// mixins
import CustomerCardActions from '@/mixins/customers/customer-card-action';

export default {
	mixins: [CustomerCardActions],
	props: {
		id: {
			type: [String, Number],
			require: true
		},
		customerParam: {
			type: Object
		}
	},
	data() {
		return {
			hasErrorModal: true,
			dataModal: {},
			form: {},
			customer: undefined,
			urlNamesCustomers: [
				{
					url: '/clients',
					name: 'Clients'
				},
				{
					url: `/clients/${this.$route.params.customerId}/forms`,
					name: 'Forms'
				},
				{ name: 'Form Details' }
			],
			urlNamesGlobalForms: [
				{
					url: `/forms`,
					name: 'Global Forms'
				},
				{ name: 'Form Details' }
			],
			navigatingFromCustomer: false
		};
	},
	async created() {
		this.customer = this.customerById(this.customerId);
		this.mainNavActions = this.actions;

		await this.getFormById(this.id);
		this.$store.commit('setCurrentPage', PageKeyNames.FORM);

		this.navigatingFromCustomer = _.startsWith(
			this.$route.path,
			'/clients'
		);
	},
	destroyed() {
		this.$store.commit('setCurrentPage', null);
	},
	computed: {
		...mapGetters('customers', ['customerById']),
		loadingSource() {
			return !this.hasFormValue;
		},
		hasFormValue() {
			return !_.isEmpty(this.form);
		},
		customerPath() {
			if (_.isEmpty(this.customerParam)) {
				return '';
			}

			return `/clients/${this.customerParam.id}`;
		},
		hasUpdatePermission() {
			return this.validatePermission('forms.update');
		},
		pageTitle() {
			if (!_.isEmpty(this.customer)) {
				return (
					this.customer.displayName || this.customer.dealershipGroup
				);
			}
			return '';
		},
		urlNames() {
			const routeBreadcrumb = this.$route.meta.breadcrumb;
			const storeBreadcrumb = this.$store.getters.breadcrumbs(
				this.$route.path
			);

			if (!_.isEmpty(routeBreadcrumb)) {
				return routeBreadcrumb;
			}

			if (!_.isEmpty(storeBreadcrumb)) {
				return storeBreadcrumb;
			}

			if (this.navigatingFromCustomer) {
				return this.urlNamesCustomers;
			}

			return this.urlNamesGlobalForms;
		}
	},
	methods: {
		...mapActions('customerForms', ['getForm']),
		async getFormById(id) {
			const self = this;
			self.getForm(id).then(response => {
				self.form = response;
			});
		},
		editForm() {
			this.$router.push({
				path: `/forms/edit/${this.form.id}/${
					this.form.formPrintType === 'I' ? 'impact' : 'laser'
				}`
			});
		}
	}
};
